import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_J_TRANSACTION_SCHEDULING = '/spe-j-transaction-scheduling';
let SpeJTransaction = class SpeJTransaction {
    constructor(api) {
        this.api = api;
    }
    updateRegister(uuid, body) {
        const uri = `${SPE_J_TRANSACTION_SCHEDULING}/v1/update-register/${uuid}`;
        return this.api.put(uri, body);
    }
    createRecurringTransaction(body) {
        const uri = `${SPE_J_TRANSACTION_SCHEDULING}/v1/recurring-transaction`;
        return this.api.post(uri, body);
    }
    createScheduling(body) {
        const uri = `${SPE_J_TRANSACTION_SCHEDULING}/v1`;
        return this.api.post(uri, body);
    }
    //obter todas as transações de uma serie de pagamentos recorrentes
    getRecurringScheduling(uuidRecurringSchedule, uuidAccountPayment) {
        const uri = `${SPE_J_TRANSACTION_SCHEDULING}/v1/uuid-recurring-schedule/${uuidRecurringSchedule}/account/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getAllScheduling(uuidAccountPayment, startExecutionDate, endExecutionDate, limit, page) {
        const uri = `${SPE_J_TRANSACTION_SCHEDULING}/v1/all?uuidAccountPayment=${uuidAccountPayment}&startExecutionDate=${startExecutionDate}&endExecutionDate=${endExecutionDate}&limit=${limit}&page=${page}`;
        return this.api.get(uri);
    }
    cancelScheduling(uuid) {
        const uri = `${SPE_J_TRANSACTION_SCHEDULING}/v1/delete-register/${uuid}`;
        return this.api.delete(uri);
    }
    cancelRecurringScheduling(uuid) {
        const uri = `${SPE_J_TRANSACTION_SCHEDULING}/v1/delete-by-uuid-recurring-schedule/${uuid}`;
        return this.api.delete(uri);
    }
    getReceiptSchedule(transactionId) {
        const uri = `${SPE_J_TRANSACTION_SCHEDULING}/v1/transaction-id/${transactionId}/simplified`;
        return this.api.get(uri);
    }
};
SpeJTransaction.ctorParameters = () => [
    { type: ApiService }
];
SpeJTransaction = __decorate([
    Injectable()
], SpeJTransaction);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

let UiPxSchedulingModule = class UiPxSchedulingModule {
};
UiPxSchedulingModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService, SpeJTransaction,
        ]
    })
], UiPxSchedulingModule);

/*
 * Public API Surface of ui-px-token
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeJTransaction, UiPxSchedulingModule };
//# sourceMappingURL=wlp-ui-px-scheduling.js.map
